/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { createRef } from 'react'
import { Grid } from 'semantic-ui-react'
import MarginHeader from './MarginHeader'
import MarginProductTable from './MarginProductTable'
import { usePlatformsWithCommissions } from './hooks/usePlatformsWithCommissions'

const Margin = () => {

  const {platformsWithCommissions, setCommissionRate, isLoading:platformLoading} = usePlatformsWithCommissions()

  return (
    <div  css={css`
        position:relative;
    
    `}>
      {/* Header Section */}
      <MarginHeader
        platforms={platformsWithCommissions} 
        isLoadingPlatforms={platformLoading}
        onCommissionRateUpdate={setCommissionRate}
      />

      {/* Content Section with Left and Right Tables */}
      <Grid css={css`
        margin: 0 !important;
      `}>
        <Grid.Column width={16} css={css`
          padding-right: 0.5rem !important;
        `}>
          {!platformLoading && <MarginProductTable platformsCommissions={platformsWithCommissions} 

            isLoadingPlatforms={platformLoading}
            />}
        </Grid.Column>

      </Grid>
    </div>
  )
}

export default Margin